/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/button/Button';
import InterestsContent from '../../components/Interests/InterestsContent';
import { validateFormAbout } from '../../config/schemas/schemas-forms';
import { useGetUserProfile } from '../../hooks/api/useUserProfile';
import ErrorField from './form/ErrorField';
import FormGroup from './form/FormGroup';
import './formeditabout.css';
import { useSelector } from 'react-redux';
import images from '../../assets/images';
import styles from './customLoading.module.css';
import { useGetOrganizationMetadata } from '../../hooks/api/useOrganization';

const FormEditAbout = ({ handleSubmit, isPostLoading }) => {
    const { data, isLoading: isGetLoading, error } = useGetUserProfile();
    const formAboutSchema = validateFormAbout();

    const { idOrganization } = useSelector(state => state.auth);
    const {
        data: organizationMetadata,
        isLoading: isGetOrganizationMetadataLoading
    } = useGetOrganizationMetadata(idOrganization);

    const availableGraduationYears = useMemo(() => {
        const years = [];
        for (let i = 1920; i <= 2030; i++) {
            years.push(i);
        }
        return years;
    }, []);

    if (error) {
        return <div>Error loading data</div>;
    }
    if (isGetLoading || isGetOrganizationMetadataLoading) {
        return (
            <div className={styles.loadingMain}>
                <img src={images.Spinner} alt="loading" />
            </div>
        );
    }

    return (
        <div className="formain">
            <div className="formain__title">
                <h1>Edit About</h1>
            </div>
            <h3 className="formain__text">* Indicates required field</h3>

            <Formik
                enableReinitialize={true}
                initialValues={{
                    about: data.about,
                    markets: data.markets,
                    solutions: data.solutions,
                    businessCategory: data.businessCategory,
                    certificationsDesignation: data.certificationsDesignation,
                    awards: data.awards,
                    undergraduateSchool: data.undergraduateSchool,
                    undergraduateSchoolLastYear:
                        data.undergraduateSchoolLastYear,
                    graduateSchool: data.graduateSchool,
                    graduateSchoolLastYear: data.graduateSchoolLastYear,
                    assocationCommittees: data.assocationCommittees,
                    volunteerInterests: data.volunteerInterests,
                    interests: data.interests
                }}
                validationSchema={formAboutSchema}
                onSubmit={values => {
                    console.log('about', values);
                    handleSubmit(values);
                }}>
                {({
                    errors,
                    values
                    // handleChange,
                    // handleBlur,
                    // setFieldValue
                }) => (
                    <Form>
                        <FormGroup label="About*" id="about">
                            <Field
                                as="textarea"
                                rows="5"
                                name="about"
                                id="about"></Field>
                            <ErrorMessage
                                name="about"
                                component={() => (
                                    <ErrorField>{errors.about}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup label="Markets*" id="markets">
                            <Field as="select" name="markets">
                                {organizationMetadata[
                                    'market-segments'
                                ]?.options?.map(market => (
                                    <option
                                        key={market.id}
                                        value={market.value}>
                                        {market.value}
                                    </option>
                                ))}
                            </Field>
                            <ErrorMessage
                                name="markets"
                                component={() => (
                                    <ErrorField>{errors.markets}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup label="Solutions*" id="solutions">
                            <Field as="select" name="solutions">
                                {organizationMetadata.solutions?.options?.map(
                                    market => (
                                        <option
                                            key={market.id}
                                            value={market.value}>
                                            {market.value}
                                        </option>
                                    )
                                )}
                            </Field>
                            <ErrorMessage
                                name="solutions"
                                component={() => (
                                    <ErrorField>{errors.solutions}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup
                            label="Business Category*"
                            id="businessCategory">
                            <Field as="select" name="businessCategory">
                                {organizationMetadata[
                                    'business-category'
                                ]?.options?.map(market => (
                                    <option
                                        key={market.id}
                                        value={market.value}>
                                        {market.value}
                                    </option>
                                ))}
                            </Field>
                            <ErrorMessage
                                name="businessCategory"
                                component={() => (
                                    <ErrorField>
                                        {errors.businessCategory}
                                    </ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup
                            label="Certifications and Designation"
                            id="certificationsDesignation">
                            <Field
                                id="certificationsDesignation"
                                type="text"
                                name="certificationsDesignation"
                            />
                            <ErrorMessage
                                name="certificationsDesignation"
                                component={() => (
                                    <ErrorField>
                                        {errors.certificationsDesignation}
                                    </ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup label="Awards" id="awards">
                            <Field id="awards" type="text" name="awards" />
                            <ErrorMessage
                                name="awards"
                                component={() => (
                                    <ErrorField>{errors.awards}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <div className="column-2">
                            <FormGroup
                                id="undergraduateSchool"
                                label="Undergraduate School">
                                <Field
                                    id="undergraduateSchool"
                                    type="text"
                                    name="undergraduateSchool"
                                    placeholder="undergraduateSchool"
                                />
                            </FormGroup>
                            <FormGroup
                                id="undergraduateSchoolLastYear"
                                label="Last year of attendance">
                                <Field
                                    as="select"
                                    name="undergraduateSchoolLastYear">
                                    {availableGraduationYears.map(year => (
                                        <option
                                            key={`undergraduate_year_${year}`}
                                            value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </Field>
                            </FormGroup>
                        </div>
                        <div className="column-2">
                            <FormGroup
                                id="graduateSchool"
                                label="Graduate School">
                                <Field
                                    id="graduateSchool"
                                    type="text"
                                    name="graduateSchool"
                                    placeholder="graduateSchool"
                                />
                            </FormGroup>
                            <FormGroup
                                id="graduateSchoolLastYear"
                                label="Last year of attendance">
                                <Field
                                    as="select"
                                    name="graduateSchoolLastYear">
                                    {availableGraduationYears.map(year => (
                                        <option
                                            key={`undergraduate_year_${year}`}
                                            value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </Field>
                            </FormGroup>
                        </div>

                        <FormGroup
                            label="Assocation Committees"
                            id="assocationCommittees">
                            <Field
                                id="assocationCommittees"
                                type="text"
                                name="assocationCommittees"
                            />
                            <ErrorMessage
                                name="assocationCommittees"
                                component={() => (
                                    <ErrorField>
                                        {errors.assocationCommittees}
                                    </ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup
                            label="Volunteer Interests"
                            id="volunteerInterests">
                            <Field
                                id="volunteerInterests"
                                type="text"
                                name="volunteerInterests"
                            />
                            <ErrorMessage
                                name="volunteerInterests"
                                component={() => (
                                    <ErrorField>
                                        {errors.volunteerInterests}
                                    </ErrorField>
                                )}
                            />
                        </FormGroup>
                        <div className="interests__title">Interests</div>
                        {/* <InterestsContent /> */}
                        <Field
                            name="interests"
                            type="checkbox"
                            component={InterestsContent}
                        />
                        <div className="text-right">
                            <ErrorMessage
                                component={() => (
                                    <ErrorField>
                                        {Object.values(errors)[0]}
                                    </ErrorField>
                                )}
                            />
                            <Button
                                spinner={isPostLoading && images.Spinner3}
                                loading={isPostLoading}
                                classs="btnMain"
                                text="Save"
                                type="submit"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

FormEditAbout.propTypes = {
    closeModalEditAbout: PropTypes.func,
    openModalAlertSuccess2: PropTypes.func,
    closeModalEditIntro: PropTypes.func
};

export default FormEditAbout;
